import React, { useEffect, useMemo } from 'react';
import { AgGridTable } from 'components/common';
import { useDispatch, useSelector } from 'react-redux';
import { getApplications } from 'redux/integration/applicationSlice';
import { Link } from "react-router-dom"
import ImpersonationBadge from './impersonation';

const ApplicationList = () => {
  const { data, loading } = useSelector((state) => state.integration_application);
  const dispatch = useDispatch();
  const applicationUrl = "/integration/applications";

  useEffect(() => {
    dispatch(getApplications());
  }, [dispatch]);

  const columnDefs = useMemo(() => [
    { 
      headerName: 'ID#',
      field: 'id',
      minWidth: 80,
      maxWidth: 100,
      cellRenderer: params => {
        const applicationId = params.value
        return <Link to={`${applicationUrl}/${applicationId}`} className="tw-text-blue-600 hover:tw-text-blue-700 tw-font-medium">{applicationId}</Link>
      }
    },
    { 
      headerName: 'Application name',
      field: 'name',
      minWidth: 200,
      cellRenderer: params => (
        <Link to={`${applicationUrl}/${params.data?.id}`} className="tw-text-slate-800 hover:tw-text-blue-700 tw-font-medium">
          {params.value}
        </Link>
      )
    },
    // The column that answers the question this screen exists for: what can this
    // client's secret actually do if it leaks?
    {
      headerName: 'Impersonation',
      field: 'impersonation_summary',
      minWidth: 170,
      cellRenderer: params => (
        <span className="tw-flex tw-items-center tw-h-full"><ImpersonationBadge record={params.data} /></span>
      )
    },
    { 
      headerName: 'Redirect uri',
      field: 'redirect_uri',
      minWidth: 260,
      cellRenderer: params => params.value || <span className="tw-text-slate-300">—</span>
    },
    { 
      headerName: 'Scopes',
      field: 'scopes',
      minWidth: 120,
    },
    { 
      headerName: 'Created date',
      field: 'created_date',
      minWidth: 170,
    }
  ], []);

  return (
    <div className="tw-bg-white tw-rounded-lg tw-border tw-border-slate-200 tw-overflow-hidden">
      <AgGridTable
        columnDefs={columnDefs}
        rowData={data || []}
        loading={loading}
        height={'60vh'}
        serverSide={false}
        filter={true}
      />
    </div>
  );
};

export default ApplicationList;
